export default "__VITE_ASSET__DMruug9h__"